module.exports = __webpack_public_path__ + "static/assets/c89740db0087cfeae03817620c993902.svg";